import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FilterPagination, ResultsInvoice } from '../../files-clients/interface/company-client.interface';
import { MatTableDataSource } from '@angular/material/table';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-table-buy-invoces',
  templateUrl: './table-buy-invoces.component.html',
  styleUrls: ['./table-buy-invoces.component.scss']
})
export class TableBuyInvocesComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @Output() pages: EventEmitter<any> = new EventEmitter();
  public icons = {faCircleMinus, faCircleCheck, faCircleXmark};
  public dataSource!: MatTableDataSource<ResultsInvoice>;
  public booleanVentas = false;
  public booleanCargandoSellInvoces = true;
  private _buyInvoices: PageResult<ResultsInvoice>;
  @Input()
  set buyInvoices(value: PageResult<ResultsInvoice>) {
    this._buyInvoices = value;
    if (value && value.results) {
      this.setDataSource(value);
      this.booleanCargandoSellInvoces = false;
    }
    if(value.totalRows==0) {
      this.booleanVentas=true;
    }
    else {this.booleanVentas=false}
  }
  get buyInvoices(): PageResult<ResultsInvoice> {
    return this._buyInvoices;
  }

  public displayedColumns: string[] = [
    'clientName',
    'clientRut',
    'totalAmount',
    'numberInvoice',
    'fechaDocto'
  ];

  ngOnInit() {
    this.setDataSource(this.buyInvoices);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['buyInvoices'] && changes['buyInvoices'].currentValue !== undefined) {
      this.setDataSource(this.buyInvoices);
    }
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe((e) => {
      const pages: FilterPagination = {
        pageSize: e.pageSize,
        page: e.pageIndex + 1,
      };
      this.pages.emit(pages);
    });
  }


  private setDataSource(dataSource: any) {
    const { results, totalRows, pageSize, currentPage } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    this.paginator.pageIndex = currentPage -1;
    this.paginator.length = totalRows;
    this.paginator.pageSize = pageSize;
  }

}
